import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import "./Global";
import FPERouter from './FPERouter';
import reportWebVitals from './reportWebVitals';
import { createTheme, MuiThemeProvider } from "@material-ui/core";
import { RecoilRoot } from "recoil";
import { ErrorBoundary } from "react-error-boundary";
import ErrorPage from "./ErrorPage";
import { AlertDisplay } from "./components/AlertDisplay";

const theme = createTheme({
  palette: {
    primary: {
      'main': "#02429C"
    }
  },
  props: {
    MuiCheckbox: {
      color: "primary"
    },
    MuiRadio: {
      color: "primary"
    },
    MuiSwitch: {
      color: "primary"
    },
    MuiList: {
      dense: true
    },
  }
})

ReactDOM.render(
  <React.StrictMode>
    <RecoilRoot>
      <ErrorBoundary FallbackComponent={ErrorPage}>
        <MuiThemeProvider theme={theme}>
          <FPERouter />
          <AlertDisplay/>
        </MuiThemeProvider>
      </ErrorBoundary>
    </RecoilRoot>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
